export default function DashboardFilterPanel({
  fields = [],
  values = {},
  onFieldChange,
  onClear,
  clearLabel = 'フィルタークリア',
}) {
  const getOptions = (field) => {
    if (typeof field.getOptions === 'function') {
      return field.getOptions({ values }) || [];
    }
    return field.options || [];
  };

  const toOptionObject = (option) => {
    if (option && typeof option === 'object') {
      return {
        value: option.value ?? '',
        label: option.label ?? option.value ?? '',
      };
    }
    return {
      value: option ?? '',
      label: option ?? '',
    };
  };

  const handleChange = (field, event) => {
    if (typeof onFieldChange !== 'function') return;
    const value = field.type === 'checkbox' ? event.target.checked : event.target.value;
    onFieldChange(field.key, value);
  };

  return (
    <div className="pm-filters">
      {fields.map((field) => {
        const fieldValue = values[field.key] ?? (field.type === 'checkbox' ? false : '');
        const fieldClassName = ['pm-filter-item', field.className].filter(Boolean).join(' ');

        if (field.type === 'select') {
          const options = getOptions(field).map(toOptionObject);
          return (
            <label className={fieldClassName} key={field.key}>
              {field.label}
              <select
                className="pm-filter-select"
                onChange={(event) => handleChange(field, event)}
                value={fieldValue}
              >
                {options.map((option) => (
                  <option key={`${field.key}-${option.value || 'empty'}`} value={option.value}>
                    {option.label || 'すべて'}
                  </option>
                ))}
              </select>
            </label>
          );
        }

        if (field.type === 'checkbox') {
          return (
            <label className={fieldClassName} key={field.key}>
              {field.label}
              <input
                checked={Boolean(fieldValue)}
                onChange={(event) => handleChange(field, event)}
                type="checkbox"
              />
            </label>
          );
        }

        return (
          <label className={fieldClassName} key={field.key}>
            {field.label}
            <input
              className="pm-filter-input"
              onChange={(event) => handleChange(field, event)}
              placeholder={field.placeholder || ''}
              type={field.type || 'text'}
              value={fieldValue}
            />
          </label>
        );
      })}

      {typeof onClear === 'function' && (
        <button className="pm-filter-clear" onClick={onClear} type="button">
          {clearLabel}
        </button>
      )}
    </div>
  );
}
